/**
 * 조직 팀 리스트를 sort 기준으로 트리 정렬 후 평탄화
 *
 * @param {Array} teamList - API에서 내려온 팀 리스트
 * @returns {Array} 정렬된 팀 리스트 (트리 순서 유지)
 */
export function sortOrganizationTree(teamList = []) {
  if (!Array.isArray(teamList) || teamList.length === 0) {
    return [];
  }

  const byCode = new Map();
  teamList.forEach(function (team) {
    byCode.set(Number(team.teamCode), team);
  });

  const childrenMap = new Map();
  const roots = [];

  teamList.forEach(function (team) {
    const teamCode = Number(team.teamCode);
    const parentCode = Number(team.departmentCode) || 0;

    if (!parentCode || !byCode.has(parentCode)) {
      roots.push(teamCode);
    } else {
      if (!childrenMap.has(parentCode)) {
        childrenMap.set(parentCode, []);
      }
      childrenMap.get(parentCode).push(teamCode);
    }
  });

  // 형제 노드 정렬
  childrenMap.forEach(function (childCodes) {
    childCodes.sort(function (a, b) {
      const aSort = byCode.get(a)?.sort ?? 0;
      const bSort = byCode.get(b)?.sort ?? 0;
      return aSort - bSort;
    });
  });

  // 루트 노드 정렬
  roots.sort(function (a, b) {
    const aSort = byCode.get(a)?.sort ?? 0;
    const bSort = byCode.get(b)?.sort ?? 0;
    return aSort - bSort;
  });

  // DFS로 평탄화
  const result = [];

  function dfs(teamCode) {
    const team = byCode.get(teamCode);
    if (!team) return;
    result.push(team);
    (childrenMap.get(teamCode) || []).forEach(dfs);
  }

  roots.forEach(dfs);

  return result;
}
